var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowClockwise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5173 2.76574C15.8411 2.76574 16.1086 3.00631 16.1509 3.31843L16.1568 3.4052V5.81675C16.1568 6.14048 15.9162 6.40803 15.6041 6.45037L15.5173 6.45621H13.1058C12.7526 6.45621 12.4663 6.16991 12.4663 5.81675C12.4663 5.49302 12.7069 5.22547 13.019 5.18313L13.1058 5.17729L13.9214 5.17691C11.4942 3.22628 7.93616 3.37713 5.68384 5.62946C3.26984 8.04346 3.26984 11.9573 5.68384 14.3713C8.09784 16.7853 12.0117 16.7853 14.4257 14.3713C15.8948 12.9022 16.5099 10.8275 16.1241 8.82476C16.0573 8.47798 16.2842 8.14269 16.631 8.07588C16.9778 8.00907 17.3131 8.23603 17.3799 8.58282C17.8452 10.998 17.1025 13.5032 15.33 15.2757C12.4166 18.1891 7.69295 18.1891 4.77951 15.2757C1.86606 12.3622 1.86606 7.63857 4.77951 4.72513C7.54668 1.95795 11.9468 1.81902 14.878 4.30834L14.8779 3.4052C14.8779 3.05204 15.1642 2.76574 15.5173 2.76574Z",
    fill: "#9B9DAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowClockwise);
export default __webpack_public_path__ + "static/media/arrow_clockwise.55c020e84dc547a3f9bc8b5f71dfcb0f.svg";
export { ForwardRef as ReactComponent };